import { render, staticRenderFns } from "./CurrentMeeting.vue?vue&type=template&id=c87db1d0&scoped=true&"
import script from "./CurrentMeeting.vue?vue&type=script&lang=js&"
export * from "./CurrentMeeting.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMeeting.vue?vue&type=style&index=0&id=c87db1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87db1d0",
  null
  
)

export default component.exports